const TYPE_LABELS: Record<string, string> = {
  C0105: "K-디지털 기초역량훈련",
  C0055: "구직자 대상 국민내일배움카드",
  C0031: "재직자 대상 국민내일배움카드",
};

export function getTypeLabel(typeCode: string): string {
  return TYPE_LABELS[typeCode] ?? typeCode;
}